import {t} from "@lingui/core/macro";
import {lazy} from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";

import {Layout, ToolCategories, type Tool} from "../types.ts";

import featherIcon from "@phosphor-icons/core/regular/feather.svg";

const CoeditingDocumentTool = lazy(
    () => import("../renderers/coediting-document-tool.tsx"),
);

export const funClassSummaryPoem: Tool = {
    urlSlug: "fun-class-summary-poem",
    configName: "teacher-tool-fun-class-summary-poem",
    title: () => t`Fun class summary poem`,
    description: () =>
        t`Transform memorable class moments into a creative poetic recap`,
    categories: [ToolCategories.Create],
    icon: featherIcon,
    color: color.fadedGreen24,
    layout: Layout.Coeditor,
    activitySlug: "activity-create-class-summary-poem",
    reportingLabelId: "write-summary-poem",
    exportTargets: [
        "print",
        "download-pdf",
        "download-docx",
        "google-drive-docx",
        "microsoft-onedrive-docx",
    ],
    requestedInputs: [
        {
            description: () =>
                t`Ask your students: what did you learn about in class today? Try to be as specific as possible!`,
            inputKind: "TEXT_AREA",
            label: () => t`Class summary`,
            required: true,
            variableName: "poemTopic",
        },
        {
            description: () =>
                t`Ask your students: what's a word or theme to inspire the poem? (e.g., joy, teamwork, or Whiskers the class pet)`,
            inputKind: "TEXT_BOX",
            label: () => t`Guiding word or theme`,
            required: true,
            variableName: "poemTheme",
        },
    ],
    component: ({providedInputs, configName, debugMode}) => {
        return (
            <CoeditingDocumentTool
                configName={configName}
                providedInputs={providedInputs}
                debugMode={debugMode}
            />
        );
    },
};
